import React from 'react';
import { PhoneCountryCodeType } from '@bus/models';
import { createOptionsList } from '../../../../../services/common/miscUtils';
import { CorrespondenceMethodEnum, TitleEnum } from '../../../../../types/forms';
import { PhoneNumberFormField } from '../../../../Fieldset/PhoneNumberFormField';
import { SelectFormField } from '../../../../Fieldset/SelectFormField';
import { TextInputFormField } from '../../../../Fieldset/TextInputFormField';
import { buildFieldName } from '../../../../../utils/fieldNameUtils';

export const createFormInputs = (formTranslationKey: string, disabled = false, fieldNamePrefix?: string) => {
  return {
    title: () => (
      <SelectFormField
        fieldName={buildFieldName('title', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:title:label`}
        optionList={createOptionsList(TitleEnum, formTranslationKey, 'title')}
        isDisabled={disabled}
      />
    ),
    firstName: () => (
      <TextInputFormField
        fieldName="firstName"
        labelTranslationKey={`${formTranslationKey}:fields:firstName:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:firstName:placeholder`}
        isDisabled={disabled}
      />
    ),
    lastName: () => (
      <TextInputFormField
        fieldName="lastName"
        labelTranslationKey={`${formTranslationKey}:fields:lastName:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:lastName:placeholder`}
        isDisabled={disabled}
      />
    ),
    email: () => (
      <TextInputFormField
        fieldName="email"
        labelTranslationKey={`${formTranslationKey}:fields:email:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:email:placeholder`}
        isDisabled={disabled}
      />
    ),
    jobTitle: () => (
      <TextInputFormField
        fieldName="jobTitle"
        labelTranslationKey={`${formTranslationKey}:fields:jobTitle:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:jobTitle:placeholder`}
        isDisabled={disabled}
      />
    ),
    countryCode: () => (
      <SelectFormField
        fieldName="countryCode"
        labelTranslationKey={`${formTranslationKey}:fields:countryCode:label`}
        optionList={createOptionsList(PhoneCountryCodeType, formTranslationKey, 'countryCode')}
        isDisabled={disabled}
      />
    ),
    phoneNumber: () => (
      <PhoneNumberFormField
        fieldName="phoneNumber"
        labelTranslationKey={`${formTranslationKey}:fields:phoneNumber:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:phoneNumber:placeholder`}
        isDisabled={disabled}
        type="mobile"
      />
    ),
    correspondenceMethod: () => (
      <SelectFormField
        fieldName="correspondenceMethod"
        labelTranslationKey={`${formTranslationKey}:fields:correspondenceMethod:label`}
        optionList={createOptionsList(CorrespondenceMethodEnum, formTranslationKey, 'correspondenceMethod')}
        isDisabled={disabled}
      />
    ),
  };
};
